import React, { Component } from "react";
import cx from "classnames";
class GameCards extends Component {
  constructor(props) {
    super(props);
    this.state = { error: false };
  }

  imageError = () => {
    let data = this.props;
    if (data.flipped) {
      this.setState({ error: true });
    }
  };

  render() {
    let data = this.props;
    const { normal = false } = this.props;

    if (data && data.modalCard && Object.keys(data).length > 0) {
      data = data.modalCard;
    }

    let text =
      data && data.flipped ? (
        data.card.text
      ) : (
        <>
          GIFs
          <br />
          Against
          <br />
          Society
        </>
      );

    let gif = data && data.flipped ? data.card.gif_url : "";
    const errorImage =
      "https://media.giphy.com/media/Ke8JKfxe83FpLrra71/giphy.gif";
    if (data && Object.keys(data).length > 0) {
      return (
        <div
          className={cx("gameCard", {
            blankCard: !data.flipped,
            gifCardCard: data.flipped,
            normal,
            "d-none": normal && !gif,
          })}
        >
          {normal ? (
            <img
              src={this.state.error ? errorImage : gif}
              alt="gif"
              onError={this.imageError}
            />
          ) : (
            <div
              className="imageBox"
              style={{
                backgroundImage: `url(${this.state.error ? errorImage : gif})`,
              }}
            />
          )}
          {/* <div
             className="imageBox"
             style={{
               backgroundImage: `url(${gif})`,
             }}
           /> */}
          {data.flipped ? (
            <p className="text bg-blue" title={text}>
              <span>{text}</span>
            </p>
          ) : (
            <p className="text">
              <span>{text}</span>
            </p>
          )}
        </div>
      );
    } else {
      return <></>;
    }
  }
}

export default GameCards;
